import { configureStore } from "../store/store";
import { IAuthUser } from "../models/user.interface";

/**
 * Gets the user from the store
 * 
 * @returns {IAuthUser} the user object
 */
const useAuth = () => {
  const { auth: { user } } = configureStore.getState() as IAuthUser;
  return user;
}

export default useAuth;